// extracted by mini-css-extract-plugin
export default {"text":"text___3Ca6t","uppercase":"uppercase___23uUP","twoColumns":"twoColumns___1ZHGu"};